<template>
    <div class="shouye-bottom">
        <div class="table-top">
            <div class="table-top-left">
                <div class="title-value">类别</div>
                <RadioGroup v-model="schedule" @on-change="scheduleClick">
                    <Radio label="1"><span>个人预约</span></Radio>
                    <Radio label="2"><span>团队预约</span></Radio>
                </RadioGroup>
                <div class="title-value">时间</div>
                <RadioGroup v-model="time" @on-change="getList">
                    <Radio label="plan_at"><span>下次跟进时间</span></Radio>
                </RadioGroup>
                <div v-show='periodShow' class="title-value">周期</div>
                <RadioGroup v-show='periodShow' v-model="period" @on-change="periodClick">
                    <Radio label="1"><span>按周</span></Radio>
                    <Radio label="2"><span>按月</span></Radio>
                </RadioGroup>
            </div>
            <div class="table-top-right" v-show='!periodShow'>
                <DatePicker type="date" @on-change="dateClick" :value='teamTime' placeholder="选择日期"
                            style="width: 150px"></DatePicker>
            </div>
        </div>
        <!-- 团队日程显示 -->
        <div v-show='!periodShow' class="team-tabel">
            <Row style="display: flex;">
                <Col class='team-title'>
                    <Select v-model="userId" style="width:90px;border:none;" @on-change="getList" placeholder="用户">
                        <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col class='team-title'>
                    <Select v-model="roleId" style="width:90px;border:none;" @on-change="getList" placeholder="角色">
                        <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col class='team-title'>
                    <Select v-model="departmentId" style="width:90px;border:none;" @on-change="getList"
                            placeholder="部门">
                        <Option v-for="item in deparmentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col class='team-title' v-for="(item,index) in weekDayList" :key='index'>{{item}}</Col>
            </Row>
            <Row style="display: flex;" v-for="(item,index) in dataList" :key='index'>
                <Col class='team-message'>{{item.name}}</Col>
                <Col class='team-message'>{{item.role_name}}</Col>
                <Col class='team-message'>{{item.department_name}}</Col>
                <Col v-for="(schedule,index2) in item.timeList" :key='index2' class='team-message'>
                    <div @click="detailClick" style="cursor: pointer;"
                         :class="{black:index2 < 7,red:index2 == 7, green:index2 >7}">
                        {{schedule.nums}}
                    </div>
                </Col>
            </Row>
        </div>
        <div v-show='!periodShow' class="team-tabel-footer">
            <div class="nei" style="background-color: #515A6E;"></div>
            <div>当日以前上门数</div>
            <div class="nei" style="background-color: red;"></div>
            <div>当日</div>
            <div class="nei" style="background-color: green;"></div>
            <div>明日以后预上门数</div>
        </div>
        <!-- 个人日程按周表格 -->
        <div v-show='periodShow' style="position: relative; top: -50px;">
            <Calendar :weekData="weekData" :monthData="monthData" @getList="getList" ref="calendar"
                      :period="period"></Calendar>
        </div>
    </div>
</template>

<script>
    import Calendar from './Calendar.vue'

    import {mapActions, mapGetters} from "vuex";
    import {
        getHomeBottom
    } from '@/api/shouye'
    import {
        getUserList, getRoleList, getDepartmentList
    } from '@/api/user'

    export default {
        name: "ShouyeBottom",
        components: {
            Calendar
        },
        computed: {
            ...mapGetters(['token']),
        },
        data() {
            return {
                weekDayList: [],
                periodShow: true,
                timeList: ['7-8点', '8-9点', '9-10点', '10-11点', '11-12点', '12-13点', '13-14点', '14-15点', '15-16点', '16-17点', '17-18点',
                    '18-19点', '19-20点', '20-21点',
                ],
                dataList: [
                ],
                teamMessage: [],
                //任务列表
                taskList: [],
                schedule: '1',
                time: 'plan_at',
                period: '1',
                teamTime: '',
                userId: '0',
                roleList: [],
                roleId: '0',
                deparmentList: [],
                departmentId: '0',
                userList: [],
                weekData: [],
                monthData: [],
            }
        },
        created() {
            var Today = new Date()
            var stryesterday = Today.format("yyyy-MM-dd")
            this.teamTime = stryesterday
            this.loadData();
            this.timestampToTime(7, this.teamTime)
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),

            dateClick(e) {
                this.teamTime = e
                this.timestampToTime(7, e);
                this.getList()
            },
            detailClick() {
                this.$router.push('/client')
            },

            timestampToTime(type, time) {
                // type =0 为当天 type = 1 为前一天
                // hhmmss 自己传需要的时分秒
                let now = new Date(time);
                let date
                if (type === 0) {
                    date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
                } else {
                    this.weekDayList = []
                    for (let i = 0; i < type; i++) {
                        let now = new Date(time);
                        date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
                        var time2 = date.getDate() + "日";
                        this.weekDayList.unshift(time2)
                    }
                    for (let i = 0; i < type + 1; i++) {
                        let now = new Date(time);
                        date = new Date(now - 3 * (-i) * 8 * 3600 * 1000); // type天前
                        var time2 = date.getDate() + "日";
                        this.weekDayList.push(time2)
                    }
                }
            },
            async loadData() {
                let data = {token: this.token}
                let that = this;
                var res = await getUserList(that, data);
                if (res.code == 1) {
                    that.userList = res.data.list;
                }
                var res = await getRoleList(that, data);
                if (res.code == 1) {
                    that.roleList = res.data.list;
                }
                var res = await getDepartmentList(that, data);
                if (res.code == 1) {
                    that.deparmentList = res.data.list;
                }
                this.getList();
            },
            async getList() {
                let that = this;
                let data = {token: this.token}
                data.schedule = this.schedule;
                data.period = this.period;
                data.teamTime = this.teamTime;
                data.time = this.time;
                if (data.schedule == 1) {
                    that.$nextTick(function () {
                        data.currentYearMonth = this.$refs.calendar.currentYearMonth
                        data.currentWeekday = this.$refs.calendar.currentWeekday
                    })
                    let res = await getHomeBottom(that, data);
                    that.weekData = res.data.weekList || [];
                    that.monthData = res.data.monthList || [];
                } else {
                    data.roleId = this.roleId;
                    data.userId = this.userId;
                    data.departmentId = this.departmentId;
                    let res = await getHomeBottom(that, data);
                    that.dataList = res.data.list;
                }
            },
            scheduleClick(e) {
                this.periodShow = !this.periodShow;
                this.getList()
            },
            //周期单选框选择触发
            periodClick(e) {
                if (e == '1') {
                    this.$refs.calendar.switchMonth()
                } else {
                    this.$refs.calendar.switchWeek()
                }
                this.getList();
            }
        }
    }
</script>


<style scoped lang="less">
    .black {
        font-weight: bold;
    }

    .red {
        color: red;
        font-weight: bold;
    }

    .green {
        color: green;
        font-weight: bold;
    }

    .scroll-css::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .scroll-css::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #cae1f5;
    }

    .scroll-css::-webkit-scrollbar-track {
        background: #fff;
    }

    .shouye-bottom {
        margin-top: 20px;
        width: 1620px;
        background-color: #FFFFFF;
        margin-bottom: 30px;
    }

    .table-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .table-top-right {
            margin-right: 30px;
        }
    }

    .table-top-left {
        display: flex;
        height: 50px;
        align-items: center;

        .title-value {
            color: #000000;
            margin-left: 30px;
            margin-right: 10px;
        }
    }

    .team-title {
        width: 90px;
        height: 40px;
        background-color: #F8F9FB;
        text-align: center;
        line-height: 40px;
        border-right: 1px solid #EBECEF;
    }

    .team-tabel {
        // width: 1530px;
        margin: 0 auto;
        border-left: 1px solid #EBECEF;
        border-top: 1px solid #EBECEF;
        border-bottom: 1px solid #EBECEF;
    }

    .team-message {
        width: 90px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-top: 1px solid #EBECEF;
        border-right: 1px solid #EBECEF;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .team-tabel-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        align-items: center;
    }

    .nei {
        height: 15px;
        width: 15px;
        border-radius: 50%;
        font-size: 10px;
        line-height: 15px;
        text-align: center;
        margin: 0 10px;
        cursor: pointer;
    }
</style>
